<template>
  <section>
    <div class="col-lg-12">
      <div class="ibox-content">
<!--        Search filters-->
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <AllRestaurants
                  @update:selectedRestaurant=" (event) => this.selectedRestaurant = event"
                  :placeholder="'Select Restaurant'"
                  :return-value="''"
                  :updateSelectedRestaurant="selectedRestaurant"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Payment Status</label>
              <select id="filter4" required="required" class="form-control">
                <option value="">Select Payment Status</option>
                <option value="paid">PAID</option>
                <option value="pending">PENDING</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Date Range</label>
              <input id="filter2" type="text" readonly="readonly" placeholder="Search By Date Range" class="form-control date_picker"/>
            </div>
          </div>
          <div class="col-md-3">
            <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_order_btn"><i class="fa fa-search"></i> Search</button>
            <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_order_btn"><i class="fa fa-refresh"></i> Refresh</button>
          </div>
        </div>
        <hr/>
<!--        Datatable-->
        <div class="row">
          <RestaurantsInvoicesStats></RestaurantsInvoicesStats>
          <hr/>
          <div class="table-responsive">
            <table class="table table-striped table-responsive table-bordered table-hover" id="RestaurantsInvoicesDtTable">
              <thead>
              <tr>
                <th>Restaurant name</th>
                <th>Invoice Number</th>
                <th>Billing Started</th>
                <th>Billing Ended</th>
                <th>Billed Amount</th>
                <th>Payment Status</th>
                <th class="text-center"><i class="fa fa-bolt"></i></th>
              </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import RestaurantsInvoicesStats from "./RestaurantsInvoicesStats";
import Multiselect from "vue-multiselect";
import AllRestaurants from "../restaurants/AllRestaurants";
export default {
    name: "RestaurantsInvoices",
    data () {
      return {
        dtTable:'',
        restaurants: [],
        selectedRestaurant: "",
      }
    },
    components: {
      AllRestaurants,
      RestaurantsInvoicesStats,
      Multiselect
    },
    watch:{
      selectedRestaurant(){
        this.dtTable.draw();
      }
    },
    mounted: function(){
      this.populateDatatable();
      let self= this;
      $('.date_picker').daterangepicker({
        format: 'YYYY-MM-DD',
      }).on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
      }).on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
      });
      $(".search_filter_order_btn").click(function(){
        self.dtTable.column(4).search( $("#filter4").val() );
        self.dtTable.column(2).search( $("#filter2").val() );
        if(self.selectedRestaurant !== "") {
          let selectedRes = (self.selectedRestaurant !== null) ? self.selectedRestaurant.id : '';
          self.dtTable.column(0).search(selectedRes);
        }
        self.dtTable.draw();
      });
      $(".refresh_filter_order_btn").click(function(){
        self.dtTable.column(4).search('');
        self.dtTable.column(2).search('');
        self.dtTable.column(0).search('');
        $("#filter4").val( '' );
        $("#filter2").val( '' );
        self.selectedRestaurant = "";
        self.dtTable.draw();
      });
    },
    methods:{
        populateDatatable: function(){
            let self = this;
            let processingURL = this.$store.state.mainAppURL + "billings/get_all_restaurants_invoice_with_pagination";
            self.dtTable = $('#RestaurantsInvoicesDtTable').DataTable({
                "processing": true,
                "serverSide": true,
                "searching": true,
                "lengthMenu": [10, 25, 50, 100, 250],
                autoWidth: false,
                "dom":'ltipr',
                'language': {
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                      Object.assign( d );
                      return JSON.stringify( d );
                    },
                    headers: {
                      "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr) => {
                      xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(this.dtTable);
                      }
                    }
                },
                "columnDefs": [
                  { "orderable": false, "targets": [0,1,2,3,5,6] },
                  { 'className': "text-center", 'aTargets': [0,1,2,3,4,5,6]},
                ],
                "columns": [
                    {
                      "data": "subscriptionId.restaurantId",
                      "name":"subscriptionId.restaurantId.name",
                      "render": function(data, type, row){
                        return data.name;
                      }},
                    { "data": "invoiceNumber","name":"invoiceNumber" },
                    {
                      "data": "billingStarted","name":"billingStarted",
                      "render": function(data, row) {
                        return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                      }
                    },
                  {
                    "data": "billingEnded","name":"billingEnded",
                    "render": function(data) {
                      return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";                    }
                  },
                    { "data": "billedAmount","name":"billedAmount",
                      "render": function (data, type, row){
                        return row.billedAmount.toFixed(2);
                      }
                    },
                    {
                      "data": "paymentStatus","name":"paymentStatus",
                      "render": function(data, type, row){
                        return "<span class= 'label " + self.$parent.getClass(data) +"'>" + data+"</span>"
                      }
                    },
                    {
                      "data": "actions", "name":"actions",
                      "render": function(data, type, row){
                        return '<a data-id="'+row.id+' '+row.subscriptionId.restaurantId.id+' " class="btn btn-xs btn-primary view_btn">View</a>';
                      }
                    }
                ],
                "drawCallback": function( settings ) {
                    $(".m_tip").tooltip();
                    $(".view_btn").click(function () {
                      let invoice= $(this).attr("data-id");
                      let billingId = invoice.split(" ")[0];
                      let restaurantId = invoice.split(" ")[1];
                      let routeData = self.$router.resolve({path: "/view_invoice"+ "?billingId=" + billingId +"&restaurantId=" + restaurantId});
                      window.open(routeData.href, '_blank');
                    });
                    $(".rest_btn").click(function () {
                      self.$emit('updateSelectedRestaurant', self.attr("data-id"));
                    })
                },
                "tableTools": {
                  "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
                }
            });
            $.fn.dataTable.ext.errMode = 'none';
        },
    },
}
</script>